import './CookieBanner.scss'

import {CookieSettings} from './CookieSettings'
import {CookieTheme} from './CookieTheme'
import React from 'react'
import {style} from '../../util/style'
import {useCookies} from '../cookies'
import {useTranslation} from '../../util/i18n'

const styles = style('cookiebanner', ['buttons', 'button', 'settings'])

export const CookieBanner: React.FC = () => {
	const {
		settings,
		updateSettings,
		settingsOpen,
		setSettingsOpen,
		bannerOpen,
		closeBanner
	} = useCookies()
	const t = useTranslation('cookies').banner
	const copy = settings.config?.banner
	if (!copy) return null

	return (
		<div className={styles.is({hidden: !bannerOpen})}>
			<CookieTheme.Container>
				<div className={styles('row')}>
					<div className={styles('content')}>
						<CookieTheme.Wysiwyg>{copy.text || t.text}</CookieTheme.Wysiwyg>
						<CookieTheme.Link
							onClick={() => setSettingsOpen(!settingsOpen)}
							mod="small"
						>
							{copy.settings || t.settings}
						</CookieTheme.Link>
					</div>
					<CookieTheme.Buttons>
						<CookieTheme.Button
							as="button"
							onClick={() => {
								updateSettings(settings.disableAll())
								closeBanner()
							}}
						>
							{copy.decline || t.decline}
						</CookieTheme.Button>
						<CookieTheme.Button
							as="button"
							onClick={() => {
								updateSettings(settings.enableAll())
								closeBanner()
							}}
						>
							{copy.accept || t.accept}
						</CookieTheme.Button>
					</CookieTheme.Buttons>
				</div>
			</CookieTheme.Container>
			<CookieSettings
				open={settingsOpen}
				onClose={() => setSettingsOpen(false)}
			/>
		</div>
	)
}
